// extracted by mini-css-extract-plugin
export var border = "_o-7";
export var brand = "_o-r";
export var button = "_o-j";
export var center = "_o-9";
export var centered = "_o-5";
export var closeButton = "_o-b";
export var disabledWrapper = "_o-k";
export var error = "_o-n";
export var extraLarge = "_o-4";
export var extraSmall = "_o-1";
export var fill = "_o-g";
export var footer = "_o-f";
export var footerAction = "_o-h";
export var footerButtons = "_o-i";
export var header = "_o-6";
export var icon = "_o-m";
export var info = "_o-q";
export var inline = "_o-8";
export var large = "_o-3";
export var main = "_o-c";
export var modal = "_o-0";
export var neutral = "_o-s";
export var noPadding = "_o-e";
export var none = "_o-t";
export var scrollable = "_o-d";
export var small = "_o-2";
export var success = "_o-p";
export var tight = "_o-l";
export var titleIcon = "_o-a";
export var warn = "_o-o";